var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M188.008-845.875a5.88,5.88,0,0,0,4.323-1.8,5.918,5.918,0,0,0,1.794-4.331,5.88,5.88,0,0,0-1.8-4.323,5.918,5.918,0,0,0-4.331-1.794,5.88,5.88,0,0,0-4.323,1.8,5.918,5.918,0,0,0-1.794,4.331,5.88,5.88,0,0,0,1.8,4.323A5.918,5.918,0,0,0,188.008-845.875ZM188-816.913q11.638-10.587,17.194-19.206T210.75-851.3q0-10.307-6.588-16.878A22,22,0,0,0,188-874.75a22,22,0,0,0-16.162,6.572q-6.588,6.572-6.588,16.878,0,6.563,5.688,15.181T188-816.913ZM188-810q-14.087-11.987-21.044-22.269T160-851.3q0-13.125,8.444-20.913A27.97,27.97,0,0,1,188-880a27.97,27.97,0,0,1,19.556,7.787Q216-864.425,216-851.3q0,8.75-6.956,19.031T188-810ZM188-852Z",
    transform: "translate(-160 880)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.38467d7071bdf78773adf1d771f1f8ad.svg";
export { ForwardRef as ReactComponent };